module.exports = __webpack_public_path__ + "media/application_advertisement/app_store_budge-e942b012.svg";